import { useAuth } from '../core/auth'
import { ALLOWED_DOMAIN } from '../core/firebase'

/**
 * Sign-in has four outcomes, and three of them are failures a person needs to
 * understand without calling anyone. "Something went wrong" is how an app
 * generates a help-desk ticket.
 */
export function SignIn() {
  const { status, signIn, signOutNow, user, signInError } = useAuth()

  if (status === 'wrong-domain') {
    return (
      <div className="state" role="alert">
        <div className="state__title">Wrong account</div>
        <p className="state__body">
          You are signed in as <strong>{user?.email}</strong>. SailNorse only works with
          your <strong>@{ALLOWED_DOMAIN}</strong> school account.
        </p>
        <button className="btn" onClick={signOutNow}>Switch accounts</button>
      </div>
    )
  }

  if (status === 'not-on-roster') {
    return (
      <div className="state" role="alert">
        <div className="state__title">You are not on the list yet</div>
        <p className="state__body">
          Your school account works, but nobody has given you access to anything.
          Ask your building admin to add you.
          It takes them about ten seconds.
        </p>
        <button className="btn btn--ghost" onClick={signOutNow}>Sign out</button>
      </div>
    )
  }

  return (
    <div className="state">
      <div className="state__title">SailNorse</div>
      <p className="state__body">Staff tools for Roland-Story. Sign in with your school account.</p>
      <button className="btn" onClick={signIn}>Sign in with Google</button>
      {signInError && (
        <div className="notice notice--critical" role="alert" style={{ marginTop: 'var(--s-4)', textAlign: 'left' }}>
          <span aria-hidden="true">⚠</span>
          <div>{signInError}</div>
        </div>
      )}
      <p className="state__body" style={{ marginTop: 'var(--s-4)', color: 'var(--ink-muted)' }}>
        Add this to your home screen and it works like an app.
      </p>
    </div>
  )
}
